import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { OverdueWcvDocument } from '../../graphql/documents.datatypes';
import { gqlDocument } from './getDocument.api';
import { gqlGroupMember } from '../Groups/getGroupMember.api';

interface OverdueGroupMemberDocumentsData {
    overdueGroupMemberDocuments: OverdueWcvDocument[]
}

export const GET_OVERDUE_DOCUMENTS_QUERY = `
    document {
        ${gqlDocument}
    }

    groupMember {
        ${gqlGroupMember}
    }
`;

const getDocumentsQuery = (query: string) => {
    if (query === '') {
        query = GET_OVERDUE_DOCUMENTS_QUERY;
    }

    return gql`
        query getOverdueGroupMemberDocuments($group_id: Int){
            overdueGroupMemberDocuments(group_id: $group_id){
                ${query}
            }
        }`;
}

export const getOverdueGroupMemberDocuments = (groupId?: number, query: string = '') => {
    return useQuery<OverdueGroupMemberDocumentsData>(
        getDocumentsQuery(query),
        {
            variables: {
                group_id: groupId,
            },

        }
    );
}

export default getOverdueGroupMemberDocuments;
